import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { NavLabelComponent } from '../../nav-label/nav-label.component';
import { NavigationNode } from '@spartacus/storefront';
import { WindowRef } from '@spartacus/core';

@Component({
  selector: 'content-4-levels',
  standalone: true,
  imports: [CommonModule, NavLabelComponent],
  templateUrl: './content-4-levels.component.html',
  styleUrl: './content-4-levels.component.scss',
})
export class Content4LevelsComponent {
  @Input() node!: NavigationNode;

  constructor(private winRef: WindowRef) {}

  setActiveContainer(index: number) {
    const $container = this.winRef.document.querySelector('.js-with-4-levels') as HTMLDivElement;
    const $nextActiveButton = $container.querySelector(`.js-btn-action[data-index="${index}"]`) as HTMLButtonElement;
    const $nextActiveContainer = $container.querySelector(
      `.js-third-level[data-index="${index}"]`,
    ) as HTMLButtonElement;

    $container.querySelectorAll('.is-active').forEach($el => {
      $el.classList.remove('is-active');
    });

    $nextActiveButton.classList.add('is-active');
    $nextActiveContainer.classList.add('is-active');
  }
}
